import React from 'react';
import Layout from '../components/Layout';
import '../styles/service-page.css';

const MermaidService = ({ user }) => {
  return (
    <Layout>
      <div className="container service-page">
        <div className="page-heading">
          <h1>Mermaid Service</h1>
          <p>Create beautiful, interactive diagrams using Mermaid syntax with enhanced AI assistance. Perfect for flowcharts, Gantt charts, and modern documentation needs.</p>
        </div>

        <div className="service-content">
          <div className="overview-section">
            <h2>Mermaid Diagram Creation</h2>
            <p>Mermaid is a powerful diagramming and charting tool that renders markdown-inspired text definitions to create and modify diagrams dynamically. Our AI-enhanced service makes Mermaid diagram creation intuitive and efficient.</p>
          </div>

          <div className="diagram-types">
            <h2>Supported Diagram Types</h2>
            <div className="types-grid">
              <div className="type-item">
                <h3>Flowcharts</h3>
                <p>Create clear process flows, decision trees, and algorithmic representations with intuitive syntax.</p>
              </div>
              <div className="type-item">
                <h3>Sequence Diagrams</h3>
                <p>Document interactions and message flows between different actors in your system.</p>
              </div>
              <div className="type-item">
                <h3>Gantt Charts</h3>
                <p>Plan and track project timelines, milestones, and dependencies with professional Gantt charts.</p>
              </div>
              <div className="type-item">
                <h3>Entity Relationship Diagrams</h3>
                <p>Model database schemas and data relationships with clean, readable ER diagrams.</p>
              </div>
              <div className="type-item">
                <h3>User Journey Maps</h3>
                <p>Visualize user experiences and touchpoints across your product or service.</p>
              </div>
              <div className="type-item">
                <h3>Git Graphs</h3>
                <p>Illustrate branching strategies and version control workflows with Git flow diagrams.</p>
              </div>
            </div>
          </div>

          <div className="features-section">
            <h2>Mermaid Advantages</h2>
            <div className="features-grid">
              <div className="feature-item">
                <h3>Interactive Diagrams</h3>
                <p>Mermaid diagrams can be interactive, allowing users to click and navigate through complex systems.</p>
              </div>
              <div className="feature-item">
                <h3>Modern Styling</h3>
                <p>Beautiful, modern aesthetics with customizable themes and styling options.</p>
              </div>
              <div className="feature-item">
                <h3>Web-Native</h3>
                <p>Perfect for web documentation, GitHub README files, and online knowledge bases.</p>
              </div>
              <div className="feature-item">
                <h3>Live Rendering</h3>
                <p>See your diagrams update in real-time as you modify the text definitions.</p>
              </div>
            </div>
          </div>

          <div className="use-cases">
            <h2>Perfect For</h2>
            <div className="use-cases-list">
              <div className="use-case">
                <h3>Project Management</h3>
                <p>Create Gantt charts, project timelines, and workflow diagrams for better project visibility.</p>
              </div>
              <div className="use-case">
                <h3>Business Analysis</h3>
                <p>Document business processes, user journeys, and decision flows with clear, professional diagrams.</p>
              </div>
              <div className="use-case">
                <h3>Software Documentation</h3>
                <p>Enhance your README files, wikis, and technical documentation with embedded diagrams.</p>
              </div>
              <div className="use-case">
                <h3>Team Collaboration</h3>
                <p>Share interactive diagrams that team members can explore and understand intuitively.</p>
              </div>
            </div>
          </div>

          <div className="cta-section">
            <h2>Start Creating with Mermaid</h2>
            <p>Experience the power of modern diagramming with our AI-enhanced Mermaid service. Create beautiful, interactive diagrams that engage your audience.</p>
            <button className="cta-button">Create Mermaid Diagrams</button>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default MermaidService;